if (!window.Eurus.loadedScript.has('featured-collection.js')) {
  window.Eurus.loadedScript.add('featured-collection.js');

  const initDragScroll = (scrollEl) => {
    if (!scrollEl || scrollEl.dataset.dragScrollInit === 'true') return;
    scrollEl.dataset.dragScrollInit = 'true';

    let pointerActive = false;
    let didDrag = false;
    let dragStartX = 0;
    let dragStartScroll = 0;
    const dragThreshold = 5;

    const stopPointer = () => {
      if (!pointerActive) return;
      pointerActive = false;
      scrollEl.classList.remove('is-dragging');
    };

    scrollEl.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      pointerActive = true;
      didDrag = false;
      dragStartX = event.clientX;
      dragStartScroll = scrollEl.scrollLeft;
    });

    scrollEl.addEventListener('pointermove', (event) => {
      if (!pointerActive) return;

      const deltaX = event.clientX - dragStartX;
      if (!didDrag && Math.abs(deltaX) < dragThreshold) return;

      if (!didDrag) {
        didDrag = true;
        scrollEl.classList.add('is-dragging');
        scrollEl.setPointerCapture(event.pointerId);
      }

      event.preventDefault();
      scrollEl.scrollLeft = dragStartScroll - deltaX;
    });

    scrollEl.addEventListener('pointerup', stopPointer);
    scrollEl.addEventListener('pointercancel', stopPointer);
    scrollEl.addEventListener('lostpointercapture', stopPointer);
    scrollEl.addEventListener(
      'click',
      (event) => {
        if (!didDrag) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        didDrag = false;
      },
      true
    );
  };

  const initDragScrollContainers = (root = document) => {
    root.querySelectorAll('[data-drag-scroll]').forEach(initDragScroll);
  };

  requestAnimationFrame(() => {
    initDragScrollContainers();

    document.addEventListener('shopify:section:load', (event) => {
      initDragScrollContainers(event.target);
    });

    document.addEventListener('alpine:init', () => {
      Alpine.data('xFeaturedCollection', (sectionId, pageParam, container) => ({
        sectionId: sectionId,
        pageParam: pageParam,
        currentTab: 1,
        loading: true,
        loaded: [],
        select(index) {
          this.currentTab = index;
        },
        loadData(index) {
          const selectedPage = index - 1;
          if (!this.loaded.includes(selectedPage)) {
            this.loading = true;
            
            let url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `x-fc-${this.sectionId}-${index}`;
              const newContent = html.getElementById(contentId);
              if (newContent && !document.getElementById(contentId)) {
                container.appendChild(newContent);
                this.loaded.push(selectedPage);
              }
              this.loading = false;
            })
          }
        },
        scrollIntoView(element) {
          const scrollableContainer = element.closest('.overflow-x-auto'); 
          const elementPosition = element.offsetLeft;

          scrollableContainer.scroll({
            left: elementPosition,
            behavior: 'smooth'
          });
        }
      }));
    });
  });
}